
// import React, { useState, useEffect } from 'react';
// import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";

// const DirectoryLevel = () => {
//     const [agencies, setAgencies] = useState([]);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [updatingId, setUpdatingId] = useState(null);
//     const [selectedLevels, setSelectedLevels] = useState({});
//     const [windowWidth, setWindowWidth] = useState(
//         typeof window !== 'undefined' ? window.innerWidth : 1200
//     );

//     /* -------------------------------------------------------------
//        NEW STATES FOR OTP MANAGEMENT
//     ------------------------------------------------------------- */
//     const [activeOtpModal, setActiveOtpModal] = useState(null); // Holds { agencyId, targetLevel } when modal is open
//     const [otpInputValue, setOtpInputValue] = useState('');     // Holds the typed 6-digit OTP string
//     const [otpSubmitting, setOtpSubmitting] = useState(false);  // True when verifying code via API

//     useEffect(() => {
//         const handleResize = () => setWindowWidth(window.innerWidth);
//         window.addEventListener('resize', handleResize);

//         const fetchAgencies = async () => {
//             try {
//                 const response = await fetch('https://taaiappapi.emedha.in/pages/api/api/agency');
//                 if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//                 const data = await response.json();
//                 setAgencies(data);
//             } catch (err) {
//                 setError(err.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAgencies();
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     /* -------------------------------------------------------------
//        STEP 1: TRIGGER REQUEST TO SEND UPGRADE OTP
//     ------------------------------------------------------------- */
//     const initiateUpgradeWorkflow = async (agencyId, targetLevel) => {
//         setUpdatingId(agencyId);
//         try {
//             const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/agency/send-upgrade-otp/${agencyId}`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' }
//             });
//             const result = await response.json();
//             if (!response.ok || !result.success) {
//                 throw new Error(result.message || 'Failed to dispatch verification security code.');
//             }
//             setActiveOtpModal({ agencyId, targetLevel });
//             setOtpInputValue('');
//         } catch (err) {
//             alert(`OTP Error: ${err.message}`);
//         } finally {
//             setUpdatingId(null);
//         }
//     };

//     /* -------------------------------------------------------------
//        STEP 2: SUBMIT AND VERIFY THE OTP
//     ------------------------------------------------------------- */
//     const handleVerifyAndUpgrade = async (e) => {
//         e.preventDefault();
//         if (!otpInputValue || otpInputValue.length < 4) {
//             alert('Please insert a valid verification security number.');
//             return;
//         }
//         const { agencyId, targetLevel } = activeOtpModal;
//         setOtpSubmitting(true);
//         try {
//             const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/agency/verify-upgrade/${agencyId}`, {
//                 method: 'PUT',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     UPGRADE_directory_level: targetLevel,
//                     otp: otpInputValue
//                 })
//             });
//             const result = await response.json();
//             if (!response.ok || !result.success) {
//                 throw new Error(result.message || 'Invalid or expired OTP code entered.');
//             }
//             setAgencies((prev) =>
//                 prev.map((item) =>
//                     (item.id === agencyId || item.membership_id === agencyId)
//                         ? { ...item, UPGRADE_directory_level: targetLevel }
//                         : item
//                 )
//             );
//             setSelectedLevels(prev => {
//                 const updated = { ...prev };
//                 delete updated[agencyId];
//                 return updated;
//             });
//             alert('Success! The membership tier has been securely updated.');
//             setActiveOtpModal(null); 
//         } catch (err) {
//             alert(`Verification Error: ${err.message}`);
//         } finally {
//             setOtpSubmitting(false);
//         }
//     };

//     const handleSelectChange = (agencyId, val) => {
//         setSelectedLevels(prev => ({
//             ...prev,
//             [agencyId]: val
//         }));
//     };

//     const maskEmail = (emailStr) => {
//         if (!emailStr || !emailStr.includes('@')) return emailStr;
//         const [namePart, domainPart] = emailStr.split('@');
//         if (namePart.length <= 2) {
//             return `${namePart.charAt(0)}***@${domainPart}`;
//         }
//         return `${namePart.charAt(0)}***${namePart.charAt(namePart.length - 1)}@${domainPart}`;
//     };

//     const filteredAgencies = agencies.filter((agency) => {
//         const term = searchQuery.toLowerCase().trim();
//         if (!term) return false;
//         return (
//             agency.agency_name?.toLowerCase().includes(term) ||
//             agency.email?.toLowerCase().includes(term) ||
//             agency.acc_rep1_email?.toLowerCase().includes(term)
//         );
//     });

//     const getGridTemplateColumns = () => {
//         if (windowWidth < 640) return '1fr';
//         if (windowWidth < 1024) return '1fr 1fr';
//         return '1fr 1fr 1fr';
//     };

//     const getDirectoryLevelData = (levelString) => {
//         const normalized = levelString?.toLowerCase().trim() || '';
//         if (normalized === 'level one') {
//             return { title: 'Level ONE - Complimentary Listing', desc: 'One Small Box with Agency Name & Contact Details', bgColor: '#f3f4f6', textColor: '#1f2937', borderColor: '#e5e7eb' };
//         } else if (normalized === 'level two') {
//             return { title: 'Level TWO - ₹2,000', desc: 'Additional Box for Profile (2x Level One) with LOGO', bgColor: '#eff6ff', textColor: '#1e40af', borderColor: '#bfdbfe' };
//         } else if (normalized === 'level three') {
//             return { title: 'Level Three – ₹5,000', desc: 'Complimentary Listing included in Strip Advertising (Full Width of the Page)', bgColor: '#faf5ff', textColor: '#6b21a8', borderColor: '#e9d5ff' };
//         }
//         return { title: levelString || 'Standard Listing', desc: 'Verified Member Account Credentials', bgColor: '#f9fafb', textColor: '#4b5563', borderColor: '#e5e7eb' };
//     };

//     if (loading) {
//         return (
//             <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '300px', gap: '16px', fontFamily: 'sans-serif' }}>
//                 <div style={{ width: '40px', height: '40px', border: '3px solid #e0e7ff', borderTopColor: '#4f46e5', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
//                 <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//                 <div style={{ fontSize: '14px', fontWeight: 500, color: '#6b7280', letterSpacing: '0.05em' }}>Loading directory...</div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div style={{ padding: '16px', maxWidth: '512px', margin: '48px auto 0', backgroundColor: '#fef2f2', border: '1px solid #fee2e2', borderRadius: '12px', textAlign: 'center', fontFamily: 'sans-serif' }}>
//                 <p style={{ fontSize: '14px', fontWeight: 600, color: '#991b1b', margin: 0 }}>Failed to connect to directory</p>
//                 <p style={{ fontSize: '12px', color: '#b91c1c', marginTop: '4px', marginBottom: 0 }}>{error}</p>
//             </div>
//         );
//     }

//     return (
//         <div style={{ minHeight: '100vh', backgroundColor: '#fafafa', padding: '48px 16px', fontFamily: 'sans-serif', boxSizing: 'border-box' }}>
//             <div style={{ maxWidth: '1152px', margin: '0 auto' }}>

//                 {/* Header Unit */}
//                 <div style={{ textAlign: 'center', maxWidth: '640px', margin: '0 auto 40px' }}>
//                     <span style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', color: '#4f46e5', backgroundColor: '#eef2ff', padding: '4px 12px', borderRadius: '9999px', textTransform: 'uppercase' }}>
//                         <img src={A1} alt="Logo" style={{ height: '77px' }} />
//                     </span>
//                     <h2 style={{ fontSize: '30px', fontWeight: 800, color: '#111827', marginTop: '12px', marginBottom: 0, letterSpacing: '-0.025em' }}>
//                         Travel Agents Association of India
//                     </h2>
//                     <p style={{ marginTop: '8px', marginBottom: 0, fontSize: '14px', color: '#6b7280' }}>
//                         Search below to find verified prime agency accounts and business representatives.
//                     </p>
//                 </div>

//                 {/* Search Input Control */}
//                 <div style={{ maxWidth: '448px', margin: '0 auto 48px' }}>
//                     <div style={{ position: 'relative', borderRadius: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//                         <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, paddingLeft: '16px', display: 'flex', alignItems: 'center', pointerEvents: 'none' }}>
//                             <svg style={{ height: '20px', width: '20px', color: '#9ca3af' }} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                                 <circle cx="11" cy="11" r="8"></circle>
//                                 <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//                             </svg>
//                         </div>
//                         <input type="text" style={{ display: 'block', width: '100%', padding: '14px 16px 14px 44px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '16px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', transition: 'all 0.15s ease' }}
//                             placeholder="Type your agency name or email address..."
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                         />
//                     </div>
//                     {searchQuery.trim() !== '' && (
//                         <div style={{ textAlign: 'right', padding: '0 8px', marginTop: '8px' }}>
//                             <span style={{ fontSize: '12px', color: '#9ca3af', fontWeight: 500 }}>
//                                 Found {filteredAgencies.length} results
//                             </span>
//                         </div>
//                     )}
//                 </div>

//                 {/* Results Matrix */}
//                 {searchQuery.trim() === '' ? (
//                     <div style={{ padding: '48px 0', maxWidth: '448px', margin: '0 auto', textAlign: 'center' }}>
//                         <p style={{ fontSize: '14px', fontWeight: 500, color: '#6b7280', margin: 0 }}>
//                             Please enter your agency name or email above to view credentials.
//                         </p>
//                     </div>
//                 ) : filteredAgencies.length === 0 ? (
//                     <div style={{ textAlign: 'center', padding: '64px 0', backgroundColor: '#ffffff', border: '1px solid #f3f4f6', borderRadius: '24px', maxWidth: '448px', margin: '0 auto', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//                         <svg style={{ margin: '0 auto', height: '48px', width: '48px', color: '#d1d5db' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                         </svg>
//                         <p style={{ marginTop: '16px', fontSize: '14px', fontWeight: 500, color: '#111827', marginBottom: 0 }}>No matching agencies found</p>
//                         <p style={{ marginTop: '4px', fontSize: '12px', color: '#9ca3af', marginBottom: 0 }}>Try checking spelling or changing your keywords.</p>
//                     </div>
//                 ) : (
//                     <div style={{ display: 'grid', gridTemplateColumns: getGridTemplateColumns(), gap: '24px' }}>
//                         {filteredAgencies.map((agency) => {
//                             const agencyIdentifier = agency.id || agency.membership_id;
//                             const isCurrentlyUpdating = updatingId === agencyIdentifier;

//                             // Here we check UPGRADE_directory_level first. If empty, fallback to directory_level.
//                             const currentActiveTier = agency.UPGRADE_directory_level || agency.directory_level || 'Level One';
//                             const currentSelectedLevel = selectedLevels[agencyIdentifier] || currentActiveTier;

//                             const levelInfo = getDirectoryLevelData(currentSelectedLevel);
//                             const hasChangedTier = selectedLevels[agencyIdentifier] !== undefined && selectedLevels[agencyIdentifier] !== currentActiveTier;

//                             return (
//                                 <div key={agencyIdentifier} style={{ backgroundColor: '#ffffff', border: '1px solid #f3f4f6', borderRadius: '16px', boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)', display: 'flex', flexDirection: 'column', overflow: 'hidden', opacity: isCurrentlyUpdating ? 0.6 : 1, transition: 'opacity 0.2s ease' }}>
//                                     <div style={{ padding: '24px', flexGrow: 1 }}>
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
//                                             <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: 500, backgroundColor: '#ecfdf5', color: '#047857', border: '1px solid #d1fae5' }}>{agency.category || 'Active'}</span>
//                                             <span style={{ fontSize: '12px', fontFamily: 'monospace', color: '#9ca3af', backgroundColor: '#f9fafb', padding: '2px 8px', borderRadius: '4px' }}>{agency.membership_id?.trim()}</span>
//                                         </div>
//                                         <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '-0.01em', margin: '0 0 16px 0', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: '44px' }}>{agency.agency_name}</h3>
//                                         <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px', color: '#6b7280', borderTop: '1px solid #f9fafb', paddingTop: '16px' }}>
//                                             <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
//                                                 <span style={{ fontWeight: 600, color: '#374151', minWidth: '45px' }}>Loc:</span>
//                                                 <span style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{agency.city}, {agency.state}</span>
//                                             </div>
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
//                                                 <span style={{ fontWeight: 600, color: '#374151', minWidth: '45px' }}>Email:</span>
//                                                 <span style={{ color: '#4f46e5', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
//                                                     {maskEmail(agency.email)}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div style={{ backgroundColor: 'rgba(249, 250, 251, 0.7)', borderTop: '1px solid #f3f4f6', padding: '16px 24px' }}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                             {agency.acc_rep1_passport_photo ? (
//                                                 <img
//                                                     style={{ height: '36px', width: '36px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #ffffff', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}
//                                                     src={agency.acc_rep1_passport_photo}
//                                                     alt={agency.acc_rep1_name}
//                                                     onError={(e) => { e.target.src = 'https://via.placeholder.com/40?text=User'; }}
//                                                 />
//                                             ) : (
//                                                 <div style={{ height: '36px', width: '36px', borderRadius: '50%', backgroundColor: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, color: '#4f46e5' }}>
//                                                     {agency.acc_rep1_name ? agency.acc_rep1_name.charAt(0) : 'A'}
//                                                 </div>
//                                             )}
//                                             <div style={{ flex: 1, minWidth: 0 }}>
//                                                 <p style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: '#9ca3af', margin: 0 }}>Representative</p>
//                                                 <p style={{ fontSize: '12px', fontWeight: 600, color: '#1f2937', margin: 0, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{agency.acc_rep1_name || 'N/A'}</p>
//                                             </div>
//                                         </div>

//                                         <div style={{ marginTop: '14px', paddingTop: '12px', borderTop: '1px solid #e5e7eb', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
//                                             {agency.air_ticketing === 1 && <span style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', color: '#4b5563', padding: '2px 8px', borderRadius: '6px', fontSize: '10px', fontWeight: 500 }}>Air Ticketing</span>}
//                                             {agency.tourism_outbound === 1 && <span style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', color: '#4b5563', padding: '2px 8px', borderRadius: '6px', fontSize: '10px', fontWeight: 500 }}>Outbound</span>}
//                                             {agency.tourism_inbound_domestic === 1 && <span style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', color: '#4b5563', padding: '2px 8px', borderRadius: '6px', fontSize: '10px', fontWeight: 500 }}>Inbound</span>}
//                                         </div>

//                                         <div style={{ marginTop: '12px', padding: '12px', backgroundColor: levelInfo.bgColor, border: `1px solid ${levelInfo.borderColor}`, borderRadius: '12px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                                             <label style={{ fontSize: '10px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
//                                                 Modify Member Category Tier:
//                                             </label>
//                                             <select value={currentSelectedLevel} disabled={isCurrentlyUpdating} onChange={(e) => handleSelectChange(agencyIdentifier, e.target.value)} style={{ width: '100%', padding: '6px 8px', fontSize: '12px', fontWeight: 600, color: levelInfo.textColor, backgroundColor: '#ffffff', border: `1px solid ${levelInfo.borderColor}`, borderRadius: '6px', outline: 'none', cursor: 'pointer' }}>
//                                                 <option value="Level One">Level ONE - Complimentary Listing</option>
//                                                 <option value="Level Two">Level TWO - ₹2,000</option>
//                                                 <option value="Level Three">Level Three – ₹5,000</option>
//                                             </select>
//                                             <span style={{ fontSize: '10px', color: '#4b5563', lineHeight: '1.4', marginTop: '2px' }}>{levelInfo.desc}</span>
//                                             {hasChangedTier && (
//                                                 <button onClick={() => initiateUpgradeWorkflow(agencyIdentifier, currentSelectedLevel)} disabled={isCurrentlyUpdating} style={{ marginTop: '6px', width: '100%', padding: '8px', fontSize: '12px', fontWeight: 700, backgroundColor: '#4f46e5', color: '#ffffff', border: 'none', borderRadius: '6px', cursor: isCurrentlyUpdating ? 'not-allowed' : 'pointer' }}>{isCurrentlyUpdating ? 'Sending OTP...' : 'Request Upgrade Level'}</button>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 )}
//                 {/* -------------------------------------------------------------
//                     NEW INTERACTIVE OVERLAY: SECURE OTP VALIDATION MODAL
//                 ------------------------------------------------------------- */}
//                 {activeOtpModal && (
//                     <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.4)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '16px' }}>
//                         <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', width: '100%', maxWidth: '400px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', overflow: 'hidden', border: '1px solid #e5e7eb', animation: 'modalSlide 0.2s ease-out' }}>
//                             {/* Modal Header */}
//                             <div style={{ padding: '20px 24px', borderBottom: '1px solid #f3f4f6', backgroundColor: '#f9fafb' }}>
//                                 <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#111827' }}>
//                                     Security Verification Required
//                                 </h3>
//                                 <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#6b7280' }}>
//                                     Target Level: <strong style={{ color: '#4f46e5' }}>{activeOtpModal.targetLevel}</strong>
//                                 </p>
//                             </div>
//                             {/* Modal Input Form Area */}
//                             <form onSubmit={handleVerifyAndUpgrade} style={{ padding: '24px' }}>
//                                 <p style={{ margin: '0 0 16px 0', fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
//                                     A 6-digit dynamic passcode was generated and dispatched to the agency's primary email profile. Please enter it below:
//                                 </p>
//                                 <input type="text" maxLength="6" placeholder="Enter 6-Digit OTP" value={otpInputValue} onChange={(e) => setOtpInputValue(e.target.value.replace(/\D/g, ''))} disabled={otpSubmitting} style={{ display: 'block', width: '100%', padding: '12px 16px', fontSize: '18px', fontWeight: 700, letterSpacing: '6px', textAlign: 'center', border: '2px solid #e5e7eb', borderRadius: '8px', outline: 'none', boxSizing: 'border-box', marginBottom: '20px' }} />
//                                 <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
//                                     <button type="button" disabled={otpSubmitting} onClick={() => setActiveOtpModal(null)} style={{ padding: '8px 16px', fontSize: '13px', fontWeight: 600, backgroundColor: '#ffffff', color: '#4b5563', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
//                                     <button type="submit" disabled={otpSubmitting} style={{ padding: '8px 20px', fontSize: '13px', fontWeight: 600, backgroundColor: '#059669', color: '#ffffff', border: 'none', borderRadius: '6px', cursor: otpSubmitting ? 'not-allowed' : 'pointer' }}>{otpSubmitting ? 'Verifying...' : 'Confirm Upgrade'}</button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default DirectoryLevel;











import React, { useState, useEffect } from 'react';
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";

const DirectoryLevel = () => {
    const [agencies, setAgencies] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [windowWidth, setWindowWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1200
    );

    // -------------------------------------------------------------
    // EDIT NOTICE MODAL
    // -------------------------------------------------------------
    const [showEditNotice, setShowEditNotice] = useState(false);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);

        window.addEventListener('resize', handleResize);

        const fetchAgencies = async () => {
            try {
                const response = await fetch(
                    'https://taaiappapi.emedha.in/pages/api/api/agency'
                );

                if (!response.ok) {
                    throw new Error(
                        `HTTP error! Status: ${response.status}`
                    );
                }

                const data = await response.json();
                setAgencies(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAgencies();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // -------------------------------------------------------------
    // EDIT BUTTON HANDLER
    // -------------------------------------------------------------
    const handleEditClick = () => {
        setShowEditNotice(true);
    };

    const closeEditNotice = () => {
        setShowEditNotice(false);
    };

    // -------------------------------------------------------------
    // MASK EMAIL
    // -------------------------------------------------------------
    const maskEmail = (emailStr) => {
        if (!emailStr || !emailStr.includes('@')) {
            return emailStr || '';
        }

        const [namePart, domainPart] = emailStr.split('@');

        if (namePart.length <= 2) {
            return `${namePart.charAt(0)}***@${domainPart}`;
        }

        return `${namePart.charAt(0)}***${namePart.charAt(
            namePart.length - 1
        )}@${domainPart}`;
    };

    // -------------------------------------------------------------
    // SEARCH
    // -------------------------------------------------------------
    const filteredAgencies = agencies.filter((agency) => {
        const term = searchQuery.toLowerCase().trim();

        if (!term) return false;

        return (
            agency.agency_name?.toLowerCase().includes(term) ||
            agency.email?.toLowerCase().includes(term) ||
            agency.acc_rep1_email?.toLowerCase().includes(term) ||
            agency.membership_id?.toLowerCase().includes(term)
        );
    });

    // -------------------------------------------------------------
    // RESPONSIVE GRID
    // -------------------------------------------------------------
    const getGridTemplateColumns = () => {
        if (windowWidth < 640) return '1fr';
        if (windowWidth < 1024) return '1fr 1fr';

        return '1fr 1fr 1fr';
    };

    // -------------------------------------------------------------
    // DIRECTORY LEVEL INFORMATION
    // -------------------------------------------------------------
    const getDirectoryLevelData = (levelString) => {
        const normalized =
            levelString?.toLowerCase().trim() || '';

        if (normalized === 'level one') {
            return {
                title: 'Level ONE - Complimentary Listing',
                desc:
                    'One Small Box with Agency Name & Contact Details',
                bgColor: '#f3f4f6',
                textColor: '#1f2937',
                borderColor: '#e5e7eb'
            };
        }

        if (normalized === 'level two') {
            return {
                title: 'Level TWO - ₹2,000',
                desc:
                    'Additional Box for Profile (2x Level One) with LOGO',
                bgColor: '#eff6ff',
                textColor: '#1e40af',
                borderColor: '#bfdbfe'
            };
        }

        if (normalized === 'level three') {
            return {
                title: 'Level Three – ₹5,000',
                desc:
                    'Complimentary Listing included in Strip Advertising (Full Width of the Page)',
                bgColor: '#faf5ff',
                textColor: '#6b21a8',
                borderColor: '#e9d5ff'
            };
        }

        return {
            title: levelString || 'Standard Listing',
            desc: 'Verified Member Account Credentials',
            bgColor: '#f9fafb',
            textColor: '#4b5563',
            borderColor: '#e5e7eb'
        };
    };

    // -------------------------------------------------------------
    // LOADING
    // -------------------------------------------------------------
    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '300px',
                    gap: '16px',
                    fontFamily: 'sans-serif'
                }}
            >
                <div
                    style={{
                        width: '40px',
                        height: '40px',
                        border: '3px solid #e0e7ff',
                        borderTopColor: '#4f46e5',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}
                />

                <style>
                    {`
                        @keyframes spin {
                            to {
                                transform: rotate(360deg);
                            }
                        }
                    `}
                </style>

                <div
                    style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#6b7280',
                        letterSpacing: '0.05em'
                    }}
                >
                    Loading directory...
                </div>
            </div>
        );
    }

    // -------------------------------------------------------------
    // ERROR
    // -------------------------------------------------------------
    if (error) {
        return (
            <div
                style={{
                    padding: '16px',
                    maxWidth: '512px',
                    margin: '48px auto 0',
                    backgroundColor: '#fef2f2',
                    border: '1px solid #fee2e2',
                    borderRadius: '12px',
                    textAlign: 'center',
                    fontFamily: 'sans-serif'
                }}
            >
                <p
                    style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#991b1b',
                        margin: 0
                    }}
                >
                    Failed to connect to directory
                </p>

                <p
                    style={{
                        fontSize: '12px',
                        color: '#b91c1c',
                        marginTop: '4px',
                        marginBottom: 0
                    }}
                >
                    {error}
                </p>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#fafafa', padding: '48px 16px', fontFamily: 'sans-serif', boxSizing: 'border-box' }}>
            {/* <div style={{ maxWidth: '1152px', margin: '0 auto' }}>

                <div style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto 40px' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                        <img src={A1} alt="TAAI Logo" style={{ height: '77px', objectFit: 'contain' }} />
                    </div>
                    <h2 style={{ fontSize: '30px', fontWeight: 800, color: '#111827', marginTop: '12px', marginBottom: 0, letterSpacing: '-0.025em' }}>Travel Agents Association of India</h2>

                    <p style={{ marginTop: '8px', marginBottom: 0, fontSize: '14px', color: '#6b7280', lineHeight: 1.6 }}>
                        Search below to find verified member accounts
                        and business representatives.
                    </p>
                </div>

                <div
                    style={{
                        maxWidth: '500px',
                        margin: '0 auto 48px'
                    }}
                >
                    <div
                        style={{
                            position: 'relative',
                            borderRadius: '16px',
                            boxShadow:
                                '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                paddingLeft: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                pointerEvents: 'none'
                            }}
                        >
                            <svg
                                style={{
                                    height: '20px',
                                    width: '20px',
                                    color: '#9ca3af'
                                }}
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    cx="11"
                                    cy="11"
                                    r="8"
                                />
                                <line
                                    x1="21"
                                    y1="21"
                                    x2="16.65"
                                    y2="16.65"
                                />
                            </svg>
                        </div>

                        <input
                            type="text"
                            style={{
                                display: 'block',
                                width: '100%',
                                padding: '14px 16px 14px 44px',
                                backgroundColor: '#ffffff',
                                border: '1px solid #e5e7eb',
                                borderRadius: '16px',
                                fontSize: '14px',
                                outline: 'none',
                                boxSizing: 'border-box',
                                transition: 'all 0.15s ease'
                            }}
                            placeholder="Type your agency name, membership ID or email..."
                            value={searchQuery}
                            onChange={(e) =>
                                setSearchQuery(e.target.value)
                            }
                        />
                    </div>

                    {searchQuery.trim() !== '' && (
                        <div
                            style={{
                                textAlign: 'right',
                                padding: '0 8px',
                                marginTop: '8px'
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '12px',
                                    color: '#9ca3af',
                                    fontWeight: 500
                                }}
                            >
                                Found {filteredAgencies.length} results
                            </span>
                        </div>
                    )}
                </div>

              
                {searchQuery.trim() === '' ? (
                    <div
                        style={{
                            padding: '48px 0',
                            maxWidth: '500px',
                            margin: '0 auto',
                            textAlign: 'center'
                        }}
                    >
                        <div
                            style={{
                                width: '56px',
                                height: '56px',
                                margin: '0 auto 16px',
                                borderRadius: '50%',
                                backgroundColor: '#eef2ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <svg
                                width="26"
                                height="26"
                                fill="none"
                                stroke="#4f46e5"
                                strokeWidth="1.8"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    cx="11"
                                    cy="11"
                                    r="7"
                                />
                                <line
                                    x1="16.5"
                                    y1="16.5"
                                    x2="21"
                                    y2="21"
                                />
                            </svg>
                        </div>

                        <p
                            style={{
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#374151',
                                margin: 0
                            }}
                        >
                            Search for your agency
                        </p>

                        <p
                            style={{
                                fontSize: '12px',
                                color: '#9ca3af',
                                marginTop: '6px'
                            }}
                        >
                            Enter your agency name, membership ID or
                            email address above.
                        </p>
                    </div>
                ) : filteredAgencies.length === 0 ? (
               
                    <div
                        style={{
                            textAlign: 'center',
                            padding: '64px 24px',
                            backgroundColor: '#ffffff',
                            border: '1px solid #f3f4f6',
                            borderRadius: '24px',
                            maxWidth: '448px',
                            margin: '0 auto',
                            boxShadow:
                                '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <svg
                            style={{
                                margin: '0 auto',
                                height: '48px',
                                width: '48px',
                                color: '#d1d5db'
                            }}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.5"
                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>

                        <p
                            style={{
                                marginTop: '16px',
                                fontSize: '14px',
                                fontWeight: 500,
                                color: '#111827',
                                marginBottom: 0
                            }}
                        >
                            No matching agencies found
                        </p>

                        <p
                            style={{
                                marginTop: '4px',
                                fontSize: '12px',
                                color: '#9ca3af',
                                marginBottom: 0
                            }}
                        >
                            Try checking spelling or changing your
                            keywords.
                        </p>
                    </div>
                ) : (
                
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                getGridTemplateColumns(),
                            gap: '24px'
                        }}
                    >
                        {filteredAgencies.map((agency) => {
                            const agencyIdentifier =
                                agency.id || agency.membership_id;

                            const currentActiveTier =
                                agency.UPGRADE_directory_level ||
                                agency.directory_level ||
                                'Level One';

                            const levelInfo =
                                getDirectoryLevelData(
                                    currentActiveTier
                                );

                            return (
                                <div
                                    key={agencyIdentifier}
                                    style={{
                                        backgroundColor: '#ffffff',
                                        border:
                                            '1px solid #f3f4f6',
                                        borderRadius: '16px',
                                        boxShadow:
                                            '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        overflow: 'hidden'
                                    }}
                                >
                                 
                                    <div
                                        style={{
                                            padding: '24px',
                                            flexGrow: 1
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent:
                                                    'space-between',
                                                alignItems: 'center',
                                                marginBottom: '12px',
                                                gap: '8px'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    display:
                                                        'inline-flex',
                                                    alignItems:
                                                        'center',
                                                    padding:
                                                        '2px 10px',
                                                    borderRadius: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    backgroundColor:
                                                        '#ecfdf5',
                                                    color: '#047857',
                                                    border:
                                                        '1px solid #d1fae5'
                                                }}
                                            >
                                                {agency.category ||
                                                    'Active'}
                                            </span>

                                            <span
                                                style={{
                                                    fontSize: '12px',
                                                    fontFamily:
                                                        'monospace',
                                                    color: '#9ca3af',
                                                    backgroundColor:
                                                        '#f9fafb',
                                                    padding:
                                                        '2px 8px',
                                                    borderRadius: '4px',
                                                    whiteSpace:
                                                        'nowrap'
                                                }}
                                            >
                                                {agency.membership_id?.trim() ||
                                                    'N/A'}
                                            </span>
                                        </div>

                                        <h3
                                            style={{
                                                fontSize: '16px',
                                                fontWeight: 700,
                                                color: '#111827',
                                                textTransform:
                                                    'uppercase',
                                                letterSpacing:
                                                    '-0.01em',
                                                margin:
                                                    '0 0 16px 0',
                                                display:
                                                    '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient:
                                                    'vertical',
                                                overflow: 'hidden',
                                                minHeight: '44px'
                                            }}
                                        >
                                            {agency.agency_name}
                                        </h3>

                                        <div
                                            style={{
                                                marginTop: '16px',
                                                display: 'flex',
                                                flexDirection:
                                                    'column',
                                                gap: '8px',
                                                fontSize: '12px',
                                                color: '#6b7280',
                                                borderTop:
                                                    '1px solid #f9fafb',
                                                paddingTop: '16px'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems:
                                                        'flex-start',
                                                    gap: '8px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontWeight: 600,
                                                        color: '#374151',
                                                        minWidth: '45px'
                                                    }}
                                                >
                                                    Loc:
                                                </span>

                                                <span
                                                    style={{
                                                        display:
                                                            '-webkit-box',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient:
                                                            'vertical',
                                                        overflow:
                                                            'hidden'
                                                    }}
                                                >
                                                    {agency.city ||
                                                        'N/A'}
                                                    {agency.city &&
                                                        agency.state
                                                        ? ', '
                                                        : ''}
                                                    {agency.state ||
                                                        ''}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems:
                                                        'center',
                                                    gap: '8px',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontWeight: 600,
                                                        color: '#374151',
                                                        minWidth: '45px'
                                                    }}
                                                >
                                                    Email:
                                                </span>

                                                <span
                                                    style={{
                                                        color: '#4f46e5',
                                                        whiteSpace:
                                                            'nowrap',
                                                        textOverflow:
                                                            'ellipsis',
                                                        overflow:
                                                            'hidden'
                                                    }}
                                                >
                                                    {maskEmail(
                                                        agency.email
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            backgroundColor:
                                                'rgba(249, 250, 251, 0.7)',
                                            borderTop:
                                                '1px solid #f3f4f6',
                                            padding:
                                                '16px 24px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems:
                                                    'center',
                                                gap: '12px'
                                            }}
                                        >
                                            {agency.acc_rep1_passport_photo ? (
                                                <img
                                                    style={{
                                                        height: '36px',
                                                        width: '36px',
                                                        borderRadius:
                                                            '50%',
                                                        objectFit:
                                                            'cover',
                                                        border:
                                                            '2px solid #ffffff',
                                                        boxShadow:
                                                            '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                                                    }}
                                                    src={
                                                        agency.acc_rep1_passport_photo
                                                    }
                                                    alt={
                                                        agency.acc_rep1_name ||
                                                        'Representative'
                                                    }
                                                    onError={(
                                                        e
                                                    ) => {
                                                        e.currentTarget.style.display =
                                                            'none';
                                                    }}
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        height: '36px',
                                                        width: '36px',
                                                        borderRadius:
                                                            '50%',
                                                        backgroundColor:
                                                            '#e0e7ff',
                                                        display:
                                                            'flex',
                                                        alignItems:
                                                            'center',
                                                        justifyContent:
                                                            'center',
                                                        fontSize:
                                                            '12px',
                                                        fontWeight: 700,
                                                        color: '#4f46e5'
                                                    }}
                                                >
                                                    {agency.acc_rep1_name
                                                        ? agency.acc_rep1_name.charAt(
                                                            0
                                                        )
                                                        : 'A'}
                                                </div>
                                            )}

                                            <div
                                                style={{
                                                    flex: 1,
                                                    minWidth: 0
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize:
                                                            '10px',
                                                        fontWeight:
                                                            700,
                                                        letterSpacing:
                                                            '0.05em',
                                                        textTransform:
                                                            'uppercase',
                                                        color: '#9ca3af',
                                                        margin: 0
                                                    }}
                                                >
                                                    Representative
                                                </p>

                                                <p
                                                    style={{
                                                        fontSize:
                                                            '12px',
                                                        fontWeight:
                                                            600,
                                                        color: '#1f2937',
                                                        margin: 0,
                                                        whiteSpace:
                                                            'nowrap',
                                                        textOverflow:
                                                            'ellipsis',
                                                        overflow:
                                                            'hidden'
                                                    }}
                                                >
                                                    {agency.acc_rep1_name ||
                                                        'N/A'}
                                                </p>
                                            </div>
                                        </div>

                                  
                                        <div
                                            style={{
                                                marginTop: '14px',
                                                paddingTop: '12px',
                                                borderTop:
                                                    '1px solid #e5e7eb',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '4px'
                                            }}
                                        >
                                            {agency.air_ticketing ===
                                                1 && (
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                '#ffffff',
                                                            border:
                                                                '1px solid #e5e7eb',
                                                            color: '#4b5563',
                                                            padding:
                                                                '2px 8px',
                                                            borderRadius:
                                                                '6px',
                                                            fontSize:
                                                                '10px',
                                                            fontWeight:
                                                                500
                                                        }}
                                                    >
                                                        Air Ticketing
                                                    </span>
                                                )}

                                            {agency.tourism_outbound ===
                                                1 && (
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                '#ffffff',
                                                            border:
                                                                '1px solid #e5e7eb',
                                                            color: '#4b5563',
                                                            padding:
                                                                '2px 8px',
                                                            borderRadius:
                                                                '6px',
                                                            fontSize:
                                                                '10px',
                                                            fontWeight:
                                                                500
                                                        }}
                                                    >
                                                        Outbound
                                                    </span>
                                                )}

                                            {agency.tourism_inbound_domestic ===
                                                1 && (
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                '#ffffff',
                                                            border:
                                                                '1px solid #e5e7eb',
                                                            color: '#4b5563',
                                                            padding:
                                                                '2px 8px',
                                                            borderRadius:
                                                                '6px',
                                                            fontSize:
                                                                '10px',
                                                            fontWeight:
                                                                500
                                                        }}
                                                    >
                                                        Inbound
                                                    </span>
                                                )}
                                        </div>

                        
                                        <div
                                            style={{
                                                marginTop: '12px',
                                                padding: '14px',
                                                backgroundColor:
                                                    levelInfo.bgColor,
                                                border: `1px solid ${levelInfo.borderColor}`,
                                                borderRadius: '12px'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                    alignItems:
                                                        'flex-start',
                                                    gap: '12px'
                                                }}
                                            >
                                                <div>
                                                    <div
                                                        style={{
                                                            fontSize:
                                                                '10px',
                                                            fontWeight:
                                                                700,
                                                            color: '#6b7280',
                                                            textTransform:
                                                                'uppercase',
                                                            letterSpacing:
                                                                '0.05em',
                                                            marginBottom:
                                                                '5px'
                                                        }}
                                                    >
                                                        Directory Level
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize:
                                                                '13px',
                                                            fontWeight:
                                                                700,
                                                            color:
                                                                levelInfo.textColor
                                                        }}
                                                    >
                                                        {
                                                            levelInfo.title
                                                        }
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize:
                                                                '10px',
                                                            color: '#4b5563',
                                                            lineHeight:
                                                                '1.4',
                                                            marginTop:
                                                                '4px'
                                                        }}
                                                    >
                                                        {
                                                            levelInfo.desc
                                                        }
                                                    </div>
                                                </div>

                                                <button
                                                    type="button"
                                                    onClick={
                                                        handleEditClick
                                                    }
                                                    style={{
                                                        flexShrink: 0,
                                                        padding:
                                                            '7px 12px',
                                                        fontSize:
                                                            '11px',
                                                        fontWeight:
                                                            700,
                                                        color: '#4f46e5',
                                                        backgroundColor:
                                                            '#ffffff',
                                                        border:
                                                            '1px solid #c7d2fe',
                                                        borderRadius:
                                                            '7px',
                                                        cursor: 'pointer',
                                                        transition:
                                                            'all 0.15s ease'
                                                    }}
                                                    onMouseEnter={(
                                                        e
                                                    ) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            '#eef2ff';
                                                    }}
                                                    onMouseLeave={(
                                                        e
                                                    ) => {
                                                        e.currentTarget.style.backgroundColor =
                                                            '#ffffff';
                                                    }}
                                                >
                                                    Edit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

             
                {showEditNotice && (
                    <div
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="edit-notice-title"
                        style={{
                            position: 'fixed',
                            inset: 0,
                            backgroundColor:
                                'rgba(17, 24, 39, 0.60)',
                            backdropFilter: 'blur(5px)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999,
                            padding: '16px',
                            boxSizing: 'border-box'
                        }}
                        onClick={closeEditNotice}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '18px',
                                width: '100%',
                                maxWidth: '620px',
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                boxShadow:
                                    '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                                border:
                                    '1px solid #e5e7eb'
                            }}
                        >
                          
                            <div
                                style={{
                                    padding: '24px 28px',
                                    backgroundColor: '#fff7ed',
                                    borderBottom:
                                        '1px solid #fed7aa'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems:
                                            'flex-start',
                                        gap: '14px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '42px',
                                            height: '42px',
                                            flexShrink: 0,
                                            borderRadius:
                                                '50%',
                                            backgroundColor:
                                                '#ffedd5',
                                            display: 'flex',
                                            alignItems:
                                                'center',
                                            justifyContent:
                                                'center',
                                            color: '#c2410c'
                                        }}
                                    >
                                        <svg
                                            width="22"
                                            height="22"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 9v4m0 4h.01M10.29 3.86l-7.4 12.82A2 2 0 004.62 19.7h14.76a2 2 0 001.73-3.02L13.71 3.86a2 2 0 00-3.42 0z"
                                            />
                                        </svg>
                                    </div>

                                    {/* <div>
                                        <h3 id="edit-notice-title" style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: '#9a3412' }}> Directory Editing Temporarily Disabled</h3>
                                        <p style={{ margin: '5px 0 0', fontSize: '12px', color: '#c2410c' }} > TAAI Directory Design & Data Finalisation</p>
                                    </div> 
                                </div>
                            </div>

                       
                            <div style={{ padding: '26px 28px' }}>
                                <p style={{ margin: '0 0 20px', fontSize: '14px', lineHeight: '1.65', color: '#374151' }}>
                                    <strong>Dear Member,</strong>
                                </p>
                                <p style={{ margin: '0 0 20px', fontSize: '13px', lineHeight: '1.7', color: '#4b5563' }}>
                                    We regret to inform you
                                    that the{' '}
                                    <strong>
                                        Edit option has been
                                        temporarily disabled
                                    </strong>
                                    , as the Directory Design
                                    is being finalised.
                                    Frequent updates and
                                    changes are causing
                                    delays in completing the
                                    Directory.
                                </p>

                  
                                <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                                    <div
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            flexShrink: 0,
                                            borderRadius:
                                                '50%',
                                            backgroundColor:
                                                '#eef2ff',
                                            color: '#4f46e5',
                                            display: 'flex',
                                            alignItems:
                                                'center',
                                            justifyContent:
                                                'center',
                                            fontSize:
                                                '11px',
                                            fontWeight:
                                                800
                                        }}
                                    >
                                        1
                                    </div>

                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize:
                                                '12px',
                                            lineHeight:
                                                '1.7',
                                            color: '#4b5563'
                                        }}
                                    >
                                        Members who have
                                        already uploaded
                                        their information
                                        will have their
                                        submitted data,
                                        particularly the
                                        Business Model and
                                        key details, included
                                        in the Directory data
                                        registered with the
                                        Association. For
                                        members who have not
                                        uploaded their
                                        information, the
                                        official data available
                                        with the TAAI
                                        Secretariat will be
                                        used.
                                    </p>
                                </div>

                      
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '12px',
                                        marginBottom:
                                            '16px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            flexShrink: 0,
                                            borderRadius:
                                                '50%',
                                            backgroundColor:
                                                '#eef2ff',
                                            color: '#4f46e5',
                                            display: 'flex',
                                            alignItems:
                                                'center',
                                            justifyContent:
                                                'center',
                                            fontSize:
                                                '11px',
                                            fontWeight:
                                                800
                                        }}
                                    >
                                        2
                                    </div>

                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize:
                                                '12px',
                                            lineHeight:
                                                '1.7',
                                            color: '#4b5563'
                                        }}
                                    >
                                        Please note that any
                                        <strong>
                                            {' '}
                                            Name Change,
                                            Address Change,
                                            or change in
                                            Authorised
                                            Representatives
                                        </strong>{' '}
                                        submitted to TAAI
                                        follows an established
                                        process. Such changes
                                        will be considered
                                        strictly as per TAAI
                                        records and not solely
                                        on the basis of
                                        information uploaded
                                        through this portal.
                                    </p>
                                </div>

                   
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '12px',
                                        marginBottom:
                                            '16px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            flexShrink: 0,
                                            borderRadius:
                                                '50%',
                                            backgroundColor:
                                                '#eef2ff',
                                            color: '#4f46e5',
                                            display: 'flex',
                                            alignItems:
                                                'center',
                                            justifyContent:
                                                'center',
                                            fontSize:
                                                '11px',
                                            fontWeight:
                                                800
                                        }}
                                    >
                                        3
                                    </div>

                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize:
                                                '12px',
                                            lineHeight:
                                                '1.7',
                                            color: '#4b5563'
                                        }}
                                    >
                                        If you have any
                                        communication or
                                        essential information
                                        to share, you may
                                        email{' '}
                                        <a
                                            href="mailto:directory@taai.in"
                                            style={{
                                                color: '#4f46e5',
                                                fontWeight:
                                                    700,
                                                textDecoration:
                                                    'none'
                                            }}
                                        >
                                            directory@taai.in
                                        </a>
                                        . Please note that
                                        updates sent by email
                                        cannot be guaranteed
                                        to be incorporated
                                        into the final
                                        Directory.
                                    </p>
                                </div>

                        
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '12px',
                                        marginBottom:
                                            '22px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            flexShrink: 0,
                                            borderRadius:
                                                '50%',
                                            backgroundColor:
                                                '#eef2ff',
                                            color: '#4f46e5',
                                            display: 'flex',
                                            alignItems:
                                                'center',
                                            justifyContent:
                                                'center',
                                            fontSize:
                                                '11px',
                                            fontWeight:
                                                800
                                        }}
                                    >
                                        4
                                    </div>

                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize:
                                                '12px',
                                            lineHeight:
                                                '1.7',
                                            color: '#4b5563'
                                        }}
                                    >
                                        The Directory has
                                        been delayed as a
                                        number of members,
                                        despite previous
                                        reminders, have not
                                        completed their
                                        information updates.
                                    </p>
                                </div>

                   
                                <div
                                    style={{
                                        padding:
                                            '14px 16px',
                                        backgroundColor:
                                            '#fef2f2',
                                        border:
                                            '1px solid #fecaca',
                                        borderRadius:
                                            '10px',
                                        marginBottom:
                                            '22px'
                                    }}
                                >
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize:
                                                '12px',
                                            lineHeight:
                                                '1.6',
                                            color: '#991b1b',
                                            fontWeight:
                                                600
                                        }}
                                    >
                                        Please note: Further
                                        editing through this
                                        portal is not available
                                        at this stage.
                                    </p>
                                </div>

                                <p
                                    style={{
                                        margin:
                                            '0 0 4px',
                                        fontSize:
                                            '13px',
                                        lineHeight:
                                            '1.6',
                                        color: '#374151'
                                    }}
                                >
                                    We thank you for your
                                    understanding and
                                    cooperation.
                                </p>

                                <p
                                    style={{
                                        margin: 0,
                                        fontSize:
                                            '13px',
                                        fontWeight: 700,
                                        color: '#111827'
                                    }}
                                >
                                    TAAI TEAM 2024–2026
                                </p>
                            </div>

              
                            <div style={{ padding: '16px 28px', borderTop: '1px solid #f3f4f6', backgroundColor: '#f9fafb', display: 'flex', justifyContent: 'flex-end' }}>
                                <button type="button" onClick={closeEditNotice} style={{ padding: '9px 22px', backgroundColor: '#4f46e5', color: '#ffffff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: 700, cursor: 'pointer' }}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div> */}

            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '20px',
                    boxSizing: 'border-box'
                }}
            >
                <div
                    style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '18px',
                        width: '100%',
                        maxWidth: '620px',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
                        border: '1px solid #e5e7eb',
                        overflow: 'hidden'
                    }}
                >

                    {/* ==============================
            HEADER
        ============================== */}
                    <div
                        style={{
                            padding: '24px 28px',
                            backgroundColor: '#fff7ed',
                            borderBottom: '1px solid #fed7aa'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '14px'
                            }}
                        >
                            {/* WARNING ICON */}
                            <div
                                style={{
                                    width: '42px',
                                    height: '42px',
                                    flexShrink: 0,
                                    borderRadius: '50%',
                                    backgroundColor: '#ffedd5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#c2410c'
                                }}
                            >
                                <svg
                                    width="22"
                                    height="22"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 9v4m0 4h.01M10.29 3.86l-7.4 12.82A2 2 0 004.62 19.7h14.76a2 2 0 001.73-3.02L13.71 3.86a2 2 0 00-3.42 0z"
                                    />
                                </svg>
                            </div>

                            {/* HEADER TEXT */}
                            <div>
                                <h2
                                    style={{
                                        margin: 0,
                                        fontSize: '18px',
                                        fontWeight: 700,
                                        color: '#9a3412'
                                    }}
                                >
                                    Directory Update Notice
                                </h2>

                                <p
                                    style={{
                                        margin: '5px 0 0',
                                        fontSize: '12px',
                                        color: '#c2410c'
                                    }}
                                >
                                    Important information for TAAI members
                                </p>
                            </div>
                        </div>
                    </div>


                    {/* ==============================
            BODY
        ============================== */}
                    <div
                        style={{
                            padding: '26px 28px'
                        }}
                    >

                        {/* INTRODUCTION */}
                        <p
                            style={{
                                margin: '0 0 20px',
                                fontSize: '14px',
                                lineHeight: '1.65',
                                color: '#374151'
                            }}
                        >
                            <strong>Dear Member,</strong>
                        </p>

                        <p
                            style={{
                                margin: '0 0 20px',
                                fontSize: '13px',
                                lineHeight: '1.7',
                                color: '#4b5563'
                            }}
                        >
                            We regret to inform you that the{' '}
                            <strong>
                                Edit option has been temporarily disabled
                            </strong>
                            , as the Directory Design is being finalised.
                            Frequent updates and changes are causing delays
                            in completing the Directory.
                        </p>


                        {/* ==============================
                NOTICE POINT 1
            ============================== */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '12px',
                                marginBottom: '16px'
                            }}
                        >
                            <div
                                style={{
                                    width: '26px',
                                    height: '26px',
                                    flexShrink: 0,
                                    borderRadius: '50%',
                                    backgroundColor: '#eef2ff',
                                    color: '#4f46e5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '11px',
                                    fontWeight: 800
                                }}
                            >
                                1
                            </div>

                            <p
                                style={{
                                    margin: 0,
                                    fontSize: '12px',
                                    lineHeight: '1.7',
                                    color: '#4b5563'
                                }}
                            >
                                Members who have already uploaded their
                                information will have their submitted data,
                                particularly the Business Model and key
                                details, included in the Directory data
                                registered with the Association. For members
                                who have not uploaded their information, the
                                official data available with the TAAI
                                Secretariat will be used.
                            </p>
                        </div>


                        {/* ==============================
                NOTICE POINT 2
            ============================== */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '12px',
                                marginBottom: '16px'
                            }}
                        >
                            <div
                                style={{
                                    width: '26px',
                                    height: '26px',
                                    flexShrink: 0,
                                    borderRadius: '50%',
                                    backgroundColor: '#eef2ff',
                                    color: '#4f46e5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '11px',
                                    fontWeight: 800
                                }}
                            >
                                2
                            </div>

                            <p
                                style={{
                                    margin: 0,
                                    fontSize: '12px',
                                    lineHeight: '1.7',
                                    color: '#4b5563'
                                }}
                            >
                                Please note that any{' '}
                                <strong>
                                    Name Change, Address Change, or change in
                                    Authorised Representatives
                                </strong>{' '}
                                submitted to TAAI follows an established
                                process. Such changes will be considered
                                strictly as per TAAI records and not solely
                                on the basis of information uploaded through
                                this portal.
                            </p>
                        </div>


                        {/* ==============================
                NOTICE POINT 3
            ============================== */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '12px',
                                marginBottom: '16px'
                            }}
                        >
                            <div
                                style={{
                                    width: '26px',
                                    height: '26px',
                                    flexShrink: 0,
                                    borderRadius: '50%',
                                    backgroundColor: '#eef2ff',
                                    color: '#4f46e5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '11px',
                                    fontWeight: 800
                                }}
                            >
                                3
                            </div>

                            <p
                                style={{
                                    margin: 0,
                                    fontSize: '12px',
                                    lineHeight: '1.7',
                                    color: '#4b5563'
                                }}
                            >
                                If you have any communication or essential
                                information to share, you may email{' '}
                                <a
                                    href="mailto:directory@taai.in"
                                    style={{
                                        color: '#4f46e5',
                                        fontWeight: 700,
                                        textDecoration: 'none'
                                    }}
                                >
                                    directory@taai.in
                                </a>
                                . Please note that updates sent by email
                                cannot be guaranteed to be incorporated into
                                the final Directory.
                            </p>
                        </div>


                        {/* ==============================
                NOTICE POINT 4
            ============================== */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '12px',
                                marginBottom: '22px'
                            }}
                        >
                            <div
                                style={{
                                    width: '26px',
                                    height: '26px',
                                    flexShrink: 0,
                                    borderRadius: '50%',
                                    backgroundColor: '#eef2ff',
                                    color: '#4f46e5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '11px',
                                    fontWeight: 800
                                }}
                            >
                                4
                            </div>

                            <p
                                style={{
                                    margin: 0,
                                    fontSize: '12px',
                                    lineHeight: '1.7',
                                    color: '#4b5563'
                                }}
                            >
                                The Directory has been delayed as a number
                                of members, despite previous reminders, have
                                not completed their information updates.
                            </p>
                        </div>


                        {/* ==============================
                IMPORTANT NOTICE
            ============================== */}
                        <div
                            style={{
                                padding: '14px 16px',
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                borderRadius: '10px',
                                marginBottom: '22px'
                            }}
                        >
                            <p
                                style={{
                                    margin: 0,
                                    fontSize: '12px',
                                    lineHeight: '1.6',
                                    color: '#991b1b',
                                    fontWeight: 600
                                }}
                            >
                                Please note: Further editing through this
                                portal is not available at this stage.
                            </p>
                        </div>


                        {/* THANK YOU MESSAGE */}
                        <p
                            style={{
                                margin: '0 0 4px',
                                fontSize: '13px',
                                lineHeight: '1.6',
                                color: '#374151'
                            }}
                        >
                            We thank you for your understanding and
                            cooperation.
                        </p>

                        <p
                            style={{
                                margin: 0,
                                fontSize: '13px',
                                fontWeight: 700,
                                color: '#111827'
                            }}
                        >
                            TAAI TEAM 2024–2026
                        </p>

                    </div>


                    {/* ==============================
            FOOTER
        ============================== */}
                    {/* <div
                        style={{
                            padding: '16px 28px',
                            borderTop: '1px solid #f3f4f6',
                            backgroundColor: '#f9fafb',
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <button
                            type="button"
                            onClick={closeEditNotice}
                            style={{
                                padding: '9px 22px',
                                backgroundColor: '#4f46e5',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 700,
                                cursor: 'pointer'
                            }}
                        >
                            Close
                        </button>
                    </div> */}

                </div>
            </div>

        </div>
    );
};

export default DirectoryLevel;
